import React from 'react';
import { Link } from 'react-router-dom';
import { Play, ArrowRight } from 'lucide-react';

const FeaturedArtistCard = ({ artist, onPlay }) => (
  <div
    className="bg-gradient-to-br from-silver-900/30 to-silver-900/10 border-2 border-silver-400/30 rounded-2xl overflow-hidden group flex flex-col"
    data-testid={`featured-artist-${artist.testId}`}
  >
    <div className="relative h-80 overflow-hidden">
      <img
        src={artist.image}
        alt={artist.name}
        className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
      <span className="absolute top-4 left-4 px-3 py-1.5 bg-black/70 backdrop-blur-sm border border-silver-400/30 rounded-full text-silver-400 text-xs font-bold uppercase tracking-wider">
        {artist.tag}
      </span>
    </div>

    <div className="p-8 flex flex-col flex-1">
      <h3 className="text-white text-2xl md:text-3xl font-black mb-2">{artist.name}</h3>
      <p className="text-silver-400 text-sm uppercase tracking-wider mb-4">{artist.genre}</p>
      <p className="text-white/70 text-base leading-relaxed mb-6 line-clamp-3 flex-1">{artist.bio}</p>

      <div className="flex flex-wrap gap-4">
        <button
          onClick={() => onPlay(artist)}
          className="inline-flex items-center gap-2 px-6 py-3 bg-silver-400 hover:bg-silver-300 text-black font-bold text-xs uppercase tracking-wider rounded-lg transition-all duration-300 hover:scale-105"
          data-testid={`featured-play-${artist.testId}`}
        >
          <Play size={14} />
          Play "{artist.topTrack.title}"
        </button>
        <Link
          to={artist.pagePath}
          className="inline-flex items-center gap-2 px-6 py-3 border border-silver-400/40 hover:border-silver-400 text-white font-bold text-xs uppercase tracking-wider rounded-lg transition-all duration-300 hover:scale-105"
          data-testid={`featured-view-${artist.testId}`}
        >
          View Artist
          <ArrowRight size={14} />
        </Link>
      </div>
    </div>
  </div>
);

export const RosterSection = ({ artists, onPlay }) => (
  <section className="py-20 px-6" data-testid="featured-artists-section">
    <div className="container mx-auto">
      <h2 className="text-4xl md:text-5xl font-black mb-12 text-center">
        <span className="text-white">The </span>
        <span className="text-silver-400">Roster</span>
      </h2>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
        {artists.map((artist) => (
          <FeaturedArtistCard key={artist.testId} artist={artist} onPlay={onPlay} />
        ))}
      </div>
    </div>
  </section>
);
